<template>
  <div>
    <notifications
      position="top right"
      class="base-snackbar"
      reverse
      :type="data.type"
      :speed="400"
      :max="30"
      :width="450"
      :duration="getDuration(data)"
    >
      <template slot="body" slot-scope="props">
        <v-layout align-center :class="{'pa-2': props.item.text.length > 80}">
          <v-flex xs1>
            <span class="dot" :class="[`base-snackbar--${props.item.type}`]"></span>
          </v-flex>
          <v-flex xs10>
            <span class="title" v-html="props.item.text"></span>
          </v-flex>
          <v-flex xs1 align-self-end>
            <v-btn flat icon color="white close-icon">
              <v-icon v-if="data.buttonRefresh" @click="onRefresh">refresh</v-icon>
              <v-icon @click="onClose(props)">close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </template>
    </notifications>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      activeNotifications: {},
      activeNotificationTimeouts: {},
    };
  },
  watch: {
    data: {
      deep: true,
      handler(data) {
        if (!data.show) {
          this.$notify({ clean: true });
          this.activeNotifications = {};
          Object.keys(this.activeNotificationTimeouts).forEach((notificationKey) => {
            clearTimeout(this.activeNotificationTimeouts[notificationKey]);
          });
          this.activeNotificationTimeouts = {};
          return;
        }

        const notificationKey = this.getNotificationKey(data);

        if (this.activeNotifications[notificationKey]) {
          return;
        }

        this.activeNotifications = {
          ...this.activeNotifications,
          [notificationKey]: true,
        };
        this.$notify({ text: data.text, type: data.type });

        const duration = this.getDuration(data);
        if (duration > 0) {
          this.activeNotificationTimeouts[notificationKey] = setTimeout(() => {
            this.clearNotification(notificationKey);
          }, duration);
        }
      }
    }
  },
  methods: {
    getDuration(data) {
      return typeof data.duration === "number" ? data.duration : 6000;
    },
    getNotificationKey(data) {
      return `${data.type || "info"}::${data.text || ""}`;
    },
    clearNotification(notificationKey) {
      if (this.activeNotificationTimeouts[notificationKey]) {
        clearTimeout(this.activeNotificationTimeouts[notificationKey]);
      }

      this.$delete(this.activeNotificationTimeouts, notificationKey);
      this.$delete(this.activeNotifications, notificationKey);
    },
    onClose(props) {
      this.clearNotification(this.getNotificationKey(props.item));
      props.close();
    },
    onRefresh() {
      window.location.reload();
    }
  },
  beforeDestroy() {
    Object.keys(this.activeNotificationTimeouts).forEach((notificationKey) => {
      clearTimeout(this.activeNotificationTimeouts[notificationKey]);
    });
  }
};
</script>

<style lang="scss" scoped>
.base-snackbar {
  right: 15px !important;

  /deep/ .notification-wrapper {
    background-color: $sidebarColor;
    padding: 0 18px;
    margin: 10px 0;
    border-radius: 4px;
    line-height: 0;
  }
  /deep/ .vue-notification-wrapper {
    background-color: $sidebarColor;
    padding: 0 18px;
    margin: 10px 0;
    border-radius: 4px;
    line-height: 0;
  }

  .title {
    font-family: "TT Norms Regular" !important;
    font-size: 16px !important;
    color: #fff;
    white-space: pre-line;
  }

  .close-icon {
    text-align: right;
  }

  .dot {
    height: 8px;
    width: 8px;
    border-radius: 50%;
    display: inline-block;
    margin-right: 10px;
  }

  &--success {
    background-color: $btnSuccessColor !important;
  }

  &--info {
    background-color: #bbb !important;
  }

  &--error {
    background-color: #fe0101 !important;
  }
}
</style>
